export default {"src":"/_next/static/media/envelope-sent.108b0fc8.svg","height":106,"width":128};